import { useDispatch, useSelector } from 'react-redux';
import Router from 'utils/routing';
import Header from 'modules/common/components/Header';
import Sidebar from 'modules/common/components/Sidebar';
import GlobalStyles from 'utils/theme/globalStyles';
import hideElements from 'configs/hideElements';
import { useAppMode } from 'contexts/AppModeContext';

import { useEffect } from 'react';
import { fetchCountries } from 'modules/common/commonSlice';
import { Contexts } from 'constants/context';
import { status } from 'constants/general';
import { MainWrapper, SidebarWrapper, ContentWrapper, PageWrapper } from './MainContainer.style';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const MainContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const context = useSelector(state => state.common.context);
  const countries = useSelector(state => state.common.countries);
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  useEffect(() => {
    if (!context) return;
    if ([Contexts.Login, Contexts.Authentication].includes(context)) return;
    if (countries?.status !== status.SHOULD_CALL_API) return;
    dispatch(fetchCountries());
  }, [dispatch, context, countries]);

  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  const { isEmbedded } = useAppMode();
  const shouldShowHeader =
    context && hideElements.contextsThatHideHeader.includes(context) === false;
  const shouldShowSidebar =
    !isEmbedded && context && hideElements.contextsThatHideSidebar.includes(context) === false;

  return (
    <>
      <GlobalStyles />
      <MainWrapper>
        {shouldShowSidebar && (
          <SidebarWrapper>
            <Sidebar />
          </SidebarWrapper>
        )}
        <ContentWrapper>
          {shouldShowHeader && <Header />}
          <PageWrapper>
            <Router />
          </PageWrapper>
        </ContentWrapper>
      </MainWrapper>
    </>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

MainContainer.propTypes = {};

MainContainer.defaultProps = {};

export default MainContainer;
